import {isBrowser} from './general.js';
import {loadScriptOnce} from './utils';

loadScriptOnce('/local/templates/template3/public/js/vendor/jquery-3.2.1.min.js', function () {
  loadScriptOnce('/local/templates/template3/public/js/modules/jquery.viewportchecker.js', function () {
    const $ = window.jQuery || window.$;

    if (!$) return;

    (function (w) {
      var anchor = (function () {
        var getQueryVariable = function (variable) {
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
              return pair[1];
            }
          }
          return (false);
        };

        var init = function () {
          var anchorId = getQueryVariable('anchorId');

          if (anchorId) {
            var element = $('#' + anchorId),
              headerHeight = $('header').height();

            $('html, body').animate({
              scrollTop: element.offset().top - headerHeight - 40
            }, 500);
          }
        };

        return {
          init: init
        }
      })();

      // возвращает куки с указанным name,
      // или undefined, если ничего не найдено
      function getCookie(name) {
        var matches = document.cookie.match(new RegExp(
          "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
      }

      var animateElements = (function () {
        var def = $.Deferred();

        function animationTransform() {
          var $els = $('.animate');

          if (!$els.length) return;
          $els.viewportChecker({
            classToAdd: '-show'
          });
        }

        function addClass() {
          $('body').addClass("-load");
          def.resolve();
          return def.promise();
        }

        function init() {
          animationTransform();
          return addClass();
        }

        return {
          init: init
        }
      }());

      var scrollAnimate = (function () {
        var option = {
            forceHeight: false,
            smoothScrolling: true
          },
          def = $.Deferred();

        function init() {
          if ($('html').hasClass('bx-touch') || isBrowser.ie11()) {
            def.resolve()
          } else {
            $.getScript('/local/templates/template3/public/js/vendor/skrollr.min.js', function () {
              skrollr.init(option);
              def.resolve()
            });
          }

          return def.promise()
        }

        return {
          init: init
        }
      }());

      function hasSearchFormContent() {
        if (!$('.search-form-inner-id').length) return;

        if (typeof (w) !== 'undefined' && typeof (w.loadSearchFormContent()) === 'function') {
          w.loadSearchFormContent();
        }

        if (typeof (e) !== 'undefined' && typeof (e.loadSearchFormContent()) === 'function') {
          e.loadSearchFormContent();
        }
      }

      function hasSearchFormHeader() {
        if (!$('.search-form-id').length) return;

        if (typeof (w) !== 'undefined' && typeof (w.loadSearchFormHeader()) === 'function') {
          w.loadSearchFormHeader();
        }

        if (typeof (e) !== 'undefined' && typeof (e.loadSearchFormHeader()) === 'function') {
          e.loadSearchFormHeader();

        }
      }

      function hasBookingFormHeader() {
        if (!$('.booking-form-container').length) return;

        if (typeof (w) !== 'undefined' && typeof (w.loadBookingFormHeader()) === 'function') {
          w.loadBookingFormHeader();
        }

        if (typeof (e) !== 'undefined' && typeof (e.loadBookingFormHeader()) === 'function') {
          e.loadBookingFormHeader();
        }

        document.querySelector("main").removeAttribute("style");
      }

      var load = $.Deferred();
      load.done(
        function () {
          scrollAnimate.init();
          return animateElements.init();
        }).done(
        function () {
          anchor.init();
          hasSearchFormHeader();
          hasSearchFormContent();
          hasBookingFormHeader();
        });
      if (document.readyState === "loading") {
        document.addEventListener('DOMContentLoaded', () => {
          load.resolve();
        });
      } else {
        load.resolve();
      }
    })(window);
  });
});
